<script setup lang="ts">
import { useBreakpoints } from '@vueuse/core'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'

const isMobile = useBreakpoints({ sm: 600 }).smaller('sm')

const router = useRouter()

const { t } = useI18n({ useScope: 'global' })
</script>

<template>
  <div class="auth-page">
    <div class="container">
      <div class="app-description">
        <img
          src="@/assets/images/oldcastle_infrastructure_logo_primary_white.png"
          alt="Old Castle logo"
        />
        <div v-if="!isMobile" class="app-description__description">
          <h2>{{ t('auth.title') }}</h2>
          <div class="app-description__description__content">
            <p>{{ t('auth.subtitle') }}</p>
            <ul>
              <li>{{ t('auth.listItem1') }}</li>
              <li>{{ t('auth.listItem2') }}</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="auth-block">
        <RouterView v-slot="{ Component }">
          <Transition name="fade" appear mode="out-in">
            <component :is="Component" :key="router.currentRoute.value.path" />
          </Transition>
        </RouterView>
      </div>
    </div>
  </div>
</template>
